'use strict';

var angular = require('angular');
var dependencies = [];
module.exports = angular.module('AVRO.ScheduleChange.CommonServices', dependencies).factory('CellRendererService', require('./services/CellRendererService'));